export default function(state = { activeTab: null }, action) {
  return state;
}
